import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getHotels } from './actions'

import Paper from 'material-ui/Paper';
import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import TextField from 'material-ui/TextField';

import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'
import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5    
  },
  gridList: {
    overflowY: 'auto',
  },
};

 class HotelsContainer extends Component {
  state = {
    search: '',
    filterId: 0
  }
  componentDidMount() {
    this.props.getHotels()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.props.getHotels()
    }
  }
  renderContent() {
    let data = this.props.data;
    if (this.state.filterId !== 0 && this.state.search !== '') {
      data = data.filter(value => value.category_id === this.state.filterId && value.title.includes(this.state.search))
    } else if (this.state.filterId !== 0) {
      data = data.filter(value => value.category_id === this.state.filterId)
    } else if (this.state.search !== '') {
      data = data.filter(value => value.title.includes(this.state.search))
    }
    if (this.props.error && !this.props.data.length) {
      return  <p>{language[this.props.lang].system.incorrect}</p>
    }
    if (this.props.data.length) {
      return (
        <div style={styles.root}>
          <TextField hintText="Search" fullWidth={true} style={{ top: -10 }} onChange={(event, newValue) => {
            this.setState({ search: newValue });
          }} />
          <GridList
            cellHeight={115}
            style={styles.gridList}
            padding={10}
            cols={2}
          >
            {data.map((tile) => (
              <GridTile
                style={{ padding: 0, borderRadius: 3 }}
                titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
                containerElement={<Link to={'/details/popularHotels/'+tile.id} />}
                key={tile.img}
                title={<b>{tile.title}</b>}
                titleStyle={{ fontSize: 17 }}
                subtitle={this.props.areas.find(value => value.id === tile.area_id)['title_'+this.props.lang]}
                actionIcon={
                  <ButtonFavorite
                    onClick={(event) => {
                      event.preventDefault()
                      this.props.bookmark.some(value => value.contentType === 'popularHotels' && value.contentId === tile.id)
                      ? this.props.deleteBookmark(this.props.bookmark.find(value => value.contentId === tile.id && value.contentType === 'popularHotels').id || '')
                      : this.props.addBookmark({
                          contentType: 'popularHotels',
                          contentId: tile.id
                        })
                    }}
                    isFollow={this.props.bookmark.some(value => value.contentType === 'popularHotels' && value.contentId === tile.id)}
                  />
                }
              >
                <img src={tile.cover_photo} />
              </GridTile>
            ))}
          </GridList>
        </div>
      )
    }
  }
  render() {
    const {
      title,
      loading,
    } = language[this.props.lang].hotels.list
    const {
      filter,
      textAllFillter
    } = language[this.props.lang]
    return (
      <Paper zDepth={1} style={{
        padding: 10,
        marginTop: 10,
        paddingTop: 1
      }}>
        <div>
          <div style={{  paddingTop: 5 }}> 
            <SessionHeader 
              dropdown
              title={title}
              titleColor='rgb(0, 150, 136)'
              textSeemore={filter}
              textAllFillter={textAllFillter}
              list={this.props.areas.map(value => ({
                ...value,
                title: value['title_'+this.props.lang]
              }))}
              onClick={filterId => this.setState({ filterId })}
            />
          </div>
          {
            this.props.loading
            ? <p>{loading}</p>
            : this.renderContent()
          }
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, areas, bookmark, ...state }) => ({
  data: state.hotels.list[lang].data,
  loading: state.hotels.list.loading,
  error: state.hotels.list.error,
  lang,
  areas,
  bookmark
})
export default connect(mapStateToProps, {
  getHotels,
  addBookmark,
  deleteBookmark
})(HotelsContainer)




// WEBPACK FOOTER //
// ./src/containers/Hotels/HotelsContainer.js